import { isAxiosError } from "axios";

import { APP_PERMISSION } from "../../constants";
import { storeToken } from "../../utilities/authentication";

import { signinResponse } from "./types";
import api from "./api";

export async function loginUser(username: string, password: string): Promise<signinResponse> {
  try {
    const response = await api.post<signinResponse>(
      `${process.env.REACT_APP_ECONSENT_SUFFIX}/users/login`,
      {
        username: username,
        password: password,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_ECONSENT_API_KEY}`
        }
      }
    )

    const data = response.data;
    const hasEsignature = data.permissions.some((item) => item.name.toLowerCase().includes(APP_PERMISSION));
    if (!hasEsignature) {
      data.session_id = '';
      data.message = 'No permissions found';
    }
    return data;
  } catch (err: any) {
    if (!isAxiosError(err)) throw err;

    switch (err.response?.status) {
      case 500: throw new Error("An unexpected error occurred. Please try again later.");
      case 401:
      case 503:
        throw new Error(err.response.data);
    }
    throw err;
  }
}

export async function requestRefreshToken(): Promise<boolean> {
  const refreshToken = localStorage.getItem('refreshToken') || '';
  if (!refreshToken) return false;
  
  try {
    const suffix = process.env.REACT_APP_ECONSENT_SUFFIX ?? '';
    const response = await api.post<{
      token: string;
      refreshToken: string;
      expiryInSecond?: number;
    }>(
      `${process.env.REACT_APP_ECONSENT_URL}/${suffix}/users/refresh`,
      { refreshToken },
      {
        headers: {
          'Content-Type': 'application/json',
          'Api-Key': process.env.REACT_APP_ECONSENT_API_KEY ?? '',
        },
      }
    );

    const { token, refreshToken: newRefreshToken, expiryInSecond } = response.data;
    if (!token) return false;

    storeToken(token, newRefreshToken || refreshToken, expiryInSecond);
    return true;
  } catch {
    // Refresh failed: session expired
    return false;
  }
}